import { render, staticRenderFns } from "./BatchesRow.vue?vue&type=template&id=4d2cd654&"
import script from "./BatchesRow.vue?vue&type=script&lang=js&"
export * from "./BatchesRow.vue?vue&type=script&lang=js&"
import style0 from "./BatchesRow.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d2cd654')) {
      api.createRecord('4d2cd654', component.options)
    } else {
      api.reload('4d2cd654', component.options)
    }
    module.hot.accept("./BatchesRow.vue?vue&type=template&id=4d2cd654&", function () {
      api.rerender('4d2cd654', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/aduanas/batches/views/components/BatchesRow.vue"
export default component.exports